
import { Component, OnInit } from '@angular/core';
import { UserService } from '../services/userservice.service';
import { LoginService } from '../services/loginservice.service';
import { User, GuestUser } from '../user';
import { Router } from '@angular/router';
import { UserdataService } from '../services/userdata.service';
import { NgForm } from '@angular/forms';
import { displayadModelinf } from '../Interfaces/displayadModelinf';
import { AdDataService } from '../services/addata.service';
import { StorageService, SessionStorageService } from '../@core/common/storage.service';


interface register {
  flagcreateac: any;
  flaglogin: any;
}
@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']

})
export class RegisterComponent implements OnInit {

  title = 'FormValidation';
  mobNumberPattern = '^((\\+91-?)|0)?[0-9]{10}$';
  isValidFormSubmitted = false;
  user: User = new User();
  guestuser: GuestUser = new GuestUser();
  submitted = false;
  registerattribute: register;
  registerDetails = {
    flagcreateac: true,
    flaglogin: true,

  };
  isNew: boolean;
  message: string;
  loginerrors: any;
  constructor(
    private userService: UserService,
    private loginService: LoginService,
    private router: Router,
    private userdataservice: UserdataService,
    private addataservice: AdDataService,
    private storageservice: SessionStorageService

  ) { }


  ngOnInit() {
    $('#myButton1').click(function(){
      $('#myButton1').hide();
      $('.load').addClass('loading');
        setTimeout(function () { 
        $('.load').removeClass('loading');
        $('#myButton1').show();

      }, 2500);
      
    });
    
   }
 

  validatepwd() {
    if (this.user.password !== this.user.repassword) {
      window.alert('Password Mismatch, Retype correct Password');
      document.getElementById('password').focus();
    } else {
      this.user.password = this.user.repassword;
      this.registerDetails.flagcreateac = false;
    }
  }
  enableloginbtn() {
    this.registerDetails.flaglogin = false;
  }
  newUser(): void {
    this.submitted = false;
    this.user = new User();
  }
  save() {
    this.userService.createCustomer(this.user).subscribe(
      data => {
        console.log(data);
        if (data.status === 'Success') {
          (<any> $('#session-time-out')).modal('show');
        }
        else{
          (<any> $('#session-time')).modal('show');
         
          this.router.navigate(['/register']);
        }
      },
      event => console.log(event)
    );
    // sessionStorage.setItem('User', JSON.stringify(this.user));
    // this.userdataservice.setUserData(this.user);
    // this.gotoList();
  }

  guestLogin() {
    this.guestuser.isGuest = true;
    this.userdataservice.setUserData(this.guestuser);
    const displayadModel = JSON.parse(sessionStorage.getItem('Array'));
    if (displayadModel) {
      // this.router.navigate(['/adsummary1']);
      this.navigatetosummary();
    } else {
      this.router.navigate(['/home']);
    }
  }

  onSubmit() { }
  gotoList() {
    if (this.user.password !== this.user.repassword) {
      window.alert('Password Mismatch, Retype correct Password');
      document.getElementById('password').focus();
    } else {

      this.userdataservice.setUserData(this.user);
      const displayadModel = JSON.parse(sessionStorage.getItem('Array'));
      this.router.navigate(['/home']);
    }
    // this.router.navigate(['/adsummary1']);
    this.navigatetosummary();

  }

  navigatetosummary() {
    const adtype = this.addataservice.getAdType();
    switch (adtype) {
      case 'displayad':
        this.router.navigate(['/adsummary3']);
        break;
      case 'clasifieddspad':
        this.router.navigate(['/adsummary2']);
        break;
      case 'clasifiedtxtad':
        this.router.navigate(['/adsummary1']);
        break;
      default:
        this.router.navigate(['/home']);
        break;
    }
  }

  onClick() {
    
    this.submitted = true;
    this.save();
  }

  Login() {
    this.loginerrors = null;
    this.loginService.LoginCustomer(
      this.user.emailsignin,
      this.user.passwordsignin
    ).subscribe(
      response => {
        console.log(response);
        const displayadModel = JSON.parse(sessionStorage.getItem('Array'));
        if (response.status === 'Success') {
          const data = response.data;
          this.storageservice.setItem('token', data.jwttokens );
          this.user = response.data;
          this.userdataservice.setUserData(this.user);
          if (displayadModel) {
            this.navigatetosummary();
          } else {
            this.router.navigate(['/home']);
          }
        } else {
          this.loginerrors = response.message;
          this.router.navigate(['/register']);
        }
      },
      event => { console.log(event); }

    );

    sessionStorage.setItem('User', JSON.stringify(this.user));
    // this.gotoList();
  }

  onFormSubmit(form: NgForm) {
    this.isValidFormSubmitted = false;
    if (form.invalid) {
      return;
    }
    this.isValidFormSubmitted = true;
    form.resetForm();
  }
}
